<template>
  <scout-form :is-modified="isModified">
    <template #before-label>
      <label class="boss-checkbox">
        <input
          :checked="isModified"
          type="checkbox"
          class="boss-input-checkbox"
          data-test="input"
          @change="changeModified($event.target.checked)"
        >
        {{ name }}
      </label>
    </template>
    <div
      class="pega-work-style-slider"
      data-test="slider"
      @click="changeModified(true)"
    >
      <vue-slider
        v-model="internalVolition"
        :adsorb="true"
        :min="1"
        :max="5"
        :marks="true"
        :hide-label="true"
        :disabled="!isModified"
        tooltip="none"
        class="margin-left-3 margin-right-3"
        data-test="vue-slider"
        @change="changeVolition"
      >
        <template #dot>
          <div :class="['custom-dot', { active : isModified }]" />
        </template>
        <template #step="{ active }">
          <div :class="['custom-step', { active : isModified && active }]" />
        </template>
      </vue-slider>
      <div class="grid-x">
        <div
          class="cell small-4"
          data-test="left-label"
        >
          {{ leftLabel }}
        </div>
        <div
          class="cell small-4 text-center"
          data-test="center-label"
        >
          どちらともいえない
        </div>
        <div
          class="cell small-4 boss-align-right"
          data-test="right-label"
        >
          {{ rightLabel }}
        </div>
      </div>
    </div>
  </scout-form>
</template>

<script>
import VueSlider from 'vue-slider-component'
import ScoutForm from '@/components/atoms/ScoutForm'
export default {
  components: {
    VueSlider,
    ScoutForm
  },
  props: {
    volition: {
      type: Array,
      default: null
    },
    name: {
      type: String,
      required: true
    },
    leftLabel: {
      type: String,
      default: ''
    },
    rightLabel: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isModified: this.volition !== null,
      internalVolition: this.volition || [1, 5]
    }
  },
  methods: {
    changeModified (value) {
      if (this.isModified === value) return
      if (value) {
        this.changeVolition()
      } else {
        this.$emit('update:volition', null)
        this.$set(this, 'internalVolition', [1, 5])
      }
      this.$set(this, 'isModified', value)
    },
    changeVolition () {
      this.$emit('update:volition', { minimum: this.internalVolition[0], maximum: this.internalVolition[1] })
    }
  }
}
</script>
